// extracted by mini-css-extract-plugin
export default {"article":"Js931yD","rowDirection":"_PcHHS6","divider":"_vBSPpU"};